var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { staticClass: "stretch-grid has-search no-footer" },
    [
      _c(
        "q-collapsible",
        {
          staticClass: "search-box",
          attrs: { "collapse-icon": "fa fa-angle-down" }
        },
        [
          _c("template", { staticClass: "search-box", slot: "header" }, [
            _c(
              "h5",
              { staticStyle: { padding: "12px 0px 12px 13px", width: "100%" } },
              [
                _c("q-icon", {
                  staticStyle: { padding: "0 5px 3px" },
                  attrs: { name: "fa fa-search", color: "primary" }
                }),
                _vm._v("Class Approvals Search\n      ")
              ],
              1
            )
          ]),
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c("div", { staticClass: "sl-row no-margin" }, [
                _c(
                  "div",
                  { staticClass: "sl-col-4" },
                  [
                    _c("q-input", {
                      attrs: { "float-label": "Class ID" },
                      model: {
                        value: _vm.searchFields.CLASS_ID,
                        callback: function($$v) {
                          _vm.$set(_vm.searchFields, "CLASS_ID", $$v)
                        },
                        expression: "searchFields.CLASS_ID"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "sl-col-4" },
                  [
                    _c(
                      "q-field",
                      { attrs: { helper: _vm.currentAffiliateLabel } },
                      [
                        _c(
                          "q-input",
                          {
                            attrs: {
                              "float-label": "Affiliate",
                              "clear-value": null,
                              clearable: ""
                            },
                            on: {
                              clear: function($event) {
                                _vm.onSelectAffiliate()
                              }
                            },
                            model: {
                              value: _vm.affiliateFilter,
                              callback: function($$v) {
                                _vm.affiliateFilter = $$v
                              },
                              expression: "affiliateFilter"
                            }
                          },
                          [
                            _c("q-autocomplete", {
                              attrs: {
                                debounce: 500,
                                "float-label": "Affiliate",
                                "max-results": 10
                              },
                              on: {
                                search: _vm.onAffiliateAutocomplete,
                                selected: _vm.onSelectAffiliate
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "sl-col-4" },
                  [
                    _c("q-datetime", {
                      attrs: {
                        clearable: "",
                        before: [{ icon: "calendar_today" }],
                        type: "date",
                        format: "MM/DD/YYYY",
                        "float-label": "Class Start Date",
                        popover: ""
                      },
                      on: {
                        clear: function($event) {
                          _vm.search()
                        }
                      },
                      model: {
                        value: _vm.searchFields["CLASS.CLASS_START_DATE"],
                        callback: function($$v) {
                          _vm.$set(
                            _vm.searchFields,
                            "CLASS.CLASS_START_DATE",
                            $$v
                          )
                        },
                        expression: "searchFields['CLASS.CLASS_START_DATE']"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "sl-row no-margin" }, [
                _c(
                  "div",
                  { staticClass: "sl-col-4" },
                  [
                    _c("q-datetime", {
                      attrs: {
                        clearable: "",
                        before: [{ icon: "how_to_vote" }],
                        type: "date",
                        format: "MM/DD/YYYY",
                        "float-label": "Approval Date",
                        popover: ""
                      },
                      on: {
                        clear: function($event) {
                          _vm.search()
                        }
                      },
                      model: {
                        value: _vm.searchFields["DATE_CREATED"],
                        callback: function($$v) {
                          _vm.$set(_vm.searchFields, "DATE_CREATED", $$v)
                        },
                        expression: "searchFields['DATE_CREATED']"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "sl-col-4" },
                  [
                    _c("q-select", {
                      attrs: {
                        clearable: "",
                        "float-label": "Approval Status",
                        options: _vm.classApprovalStatuses
                      },
                      on: {
                        clear: function($event) {
                          _vm.search()
                        }
                      },
                      model: {
                        value:
                          _vm.searchFields["CLASS.LK_CLASS_APPROVAL_STATUS_ID"],
                        callback: function($$v) {
                          _vm.$set(
                            _vm.searchFields,
                            "CLASS.LK_CLASS_APPROVAL_STATUS_ID",
                            $$v
                          )
                        },
                        expression:
                          "searchFields['CLASS.LK_CLASS_APPROVAL_STATUS_ID']"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "sl-col-4" },
                  [
                    _c("q-datetime", {
                      attrs: {
                        clearable: "",
                        before: [{ icon: "calendar_today" }],
                        type: "date",
                        format: "MM/DD/YYYY",
                        "float-label": "Class End Date",
                        popover: ""
                      },
                      on: {
                        clear: function($event) {
                          _vm.search()
                        }
                      },
                      model: {
                        value: _vm.searchFields["CLASS.CLASS_END_DATE"],
                        callback: function($$v) {
                          _vm.$set(
                            _vm.searchFields,
                            "CLASS.CLASS_END_DATE",
                            $$v
                          )
                        },
                        expression: "searchFields['CLASS.CLASS_END_DATE']"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c(
                "q-toolbar",
                {
                  staticStyle: { "padding-right": "60px" },
                  attrs: { color: "white" }
                },
                [
                  _c("q-toolbar-title"),
                  _c("q-btn", {
                    staticStyle: { "margin-right": "5px" },
                    attrs: {
                      color: "secondary",
                      label: "Clear",
                      outline: "",
                      size: "sm",
                      type: "reset"
                    },
                    on: { click: _vm.fetchAndClear }
                  }),
                  _c("q-btn", {
                    attrs: {
                      color: "primary",
                      label: "Search",
                      size: "sm",
                      type: "submit"
                    },
                    on: {
                      click: function($event) {
                        _vm.search()
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        2
      ),
      _c("Grid", {
        staticClass: "fit",
        attrs: {
          id: "classApprovalsGrid",
          expandable: true,
          module: _vm.module,
          data: _vm.approvalList,
          columns: _vm.columnOptions,
          loadingData: _vm.loadingData,
          filterable: _vm.filterable,
          pagination: _vm.paginationOptions,
          onExport: _vm.fetchClassApprovals,
          onLaunch: _vm.select,
          onRequest: _vm.onFetch
        },
        scopedSlots: _vm._u([
          {
            key: "col-item-status",
            fn: function(props) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "label small",
                    class: {
                      blue:
                        props.value == "SUBMITTED" ||
                        props.value == "RESUBMITTED",
                      green: props.value == "APPROVED",
                      red: props.value == "REJECTED",
                      yellow: props.value == "EXPIRED",
                      grey: props.value == "NOT SUBMITTED"
                    },
                    staticStyle: {
                      display: "inline-block",
                      "margin-left": "10px",
                      "border-radius": "30px"
                    }
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(props.value) +
                        "\n            "
                    )
                  ]
                )
              ]
            }
          },
          {
            key: "col-item-class_start_date",
            fn: function(props) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.moment(props.value).format("MMMM Do, YYYY h:mm A")
                    ) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "col-item-date_created",
            fn: function(props) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.moment(props.value).format("MMMM Do, YYYY h:mm A")
                    ) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "col-item-expand",
            fn: function(props) {
              return [
                _c(
                  "div",
                  { staticClass: "sessions-table" },
                  [
                    _c("div", { staticClass: "sl-row table-head" }, [
                      _c("div", { staticClass: "sl-col-12" }, [
                        _vm._v("\n            Approval History\n          ")
                      ])
                    ]),
                    _c("div", { staticClass: "sl-row table-columns" }, [
                      _c("div", { staticClass: "sl-col-3" }, [
                        _vm._v("\n            Date Updated\n          ")
                      ]),
                      _c("div", { staticClass: "sl-col-2" }, [
                        _vm._v("\n            Status \n          ")
                      ]),
                      _c("div", { staticClass: "sl-col-4" }, [
                        _vm._v("\n            Notes\n          ")
                      ])
                    ]),
                    _vm._l(props.props.row.HISTORY, function(approval) {
                      return _c(
                        "div",
                        {
                          key: approval.INSTRUCTOR_APPROVAL_ID,
                          staticClass: "sl-row"
                        },
                        [
                          _c("div", { staticClass: "sl-col-3" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm
                                    .moment(approval.DATE_CREATED)
                                    .format("MMMM Do, YYYY h:mm A")
                                ) +
                                "\n          "
                            )
                          ]),
                          _c("div", { staticClass: "sl-col-2" }, [
                            _c(
                              "div",
                              {
                                staticClass: "label small",
                                class: {
                                  blue:
                                    approval.LK_CLASS_APPROVAL_STATUS_ID == 1 ||
                                    approval.LK_CLASS_APPROVAL_STATUS_ID == 5,
                                  grey:
                                    approval.LK_CLASS_APPROVAL_STATUS_ID == 6,
                                  yellow:
                                    approval.LK_CLASS_APPROVAL_STATUS_ID == 4,
                                  green:
                                    approval.LK_CLASS_APPROVAL_STATUS_ID == 2,
                                  red: approval.LK_CLASS_APPROVAL_STATUS_ID == 3
                                },
                                staticStyle: {
                                  display: "inline-block",
                                  "margin-left": "10px",
                                  "border-radius": "30px"
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.lookupApprovalStatus(
                                        approval.LK_CLASS_APPROVAL_STATUS_ID
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          ]),
                          _c("div", { staticClass: "sl-col-4" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(approval.NOTES) +
                                "\n          "
                            )
                          ])
                        ]
                      )
                    })
                  ],
                  2
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }